<script>
  import tipoUsuario from '~js/tipo-usuario';

  export default {
    name: 'ChatBotWidget',
    data() {
      return {
        isOpen: false,
        iframeLoaded: false,
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      isaacHubUrl() {
        // CamelCasePropertyNamesContractResolver do .NET converte para camelCase no JSON
        return this.configuracao && this.configuracao.urlIsaacHubFundacaoWeb
          ? this.configuracao.urlIsaacHubFundacaoWeb.replace(/\/+$/, '')
          : '';
      },
      isVisible() {
        return !!(
          this.isaacHubUrl &&
          this.usuario &&
          this.usuario.tipoUsuario === tipoUsuario.Coordenador
        );
      }
    },
    methods: {
      toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          this.iframeLoaded = true;
        }
      },
      close() {
        this.isOpen = false;
      }
    }
  }
</script>

<template>
  <div v-if="isVisible" class="hidden-print chatbot-widget-root">
    <!-- Botão fechado: position absolute, acompanha o scroll (junto do footer) -->
    <button
      v-show="!isOpen"
      type="button"
      class="chatbot-widget-fab-closed"
      @click="toggle"
      title="Assistente Virtual">
      <i class="fa fa-comments" style="font-size:14px;"></i>
    </button>

    <!-- Chat aberto: botão X acima + janela abaixo -->
    <div v-show="isOpen" class="chatbot-widget-open-container">
      <!-- Botão X flutuante acima da janela -->
      <button
        type="button"
        class="chatbot-widget-fab-open"
        @click="close"
        title="Fechar chat">
        <i class="fa fa-times" style="font-size:16px;"></i>
      </button>

      <!-- Janela do chat -->
      <div class="chatbot-widget-window">
        <div class="chatbot-widget-header">
          <span>
            <i class="fa fa-comments" style="margin-right:8px;"></i>
            Assistente Virtual
          </span>
        </div>
        <iframe
          v-if="iframeLoaded"
          :src="isaacHubUrl"
          class="chatbot-widget-iframe"
          allow="clipboard-write"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<style>
  .chatbot-widget-root {
    position: static;
    width: 0;
    height: 0;
    overflow: visible;
  }

  /* Fechado: absolute no page-wrapper, acompanha o scroll com o footer */
  .chatbot-widget-fab-closed {
    position: absolute;
    bottom: 15px;
    right: 44px;
    z-index: 999;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background: #1ab394;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.2s ease;
  }

  .chatbot-widget-fab-closed:hover {
    background: #18a689;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    transform: scale(1.1);
  }

  .chatbot-widget-fab-closed:focus {
    outline: none;
  }

  /* Container fixo quando aberto */
  .chatbot-widget-open-container {
    position: fixed;
    bottom: 15px;
    right: 15px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }

  /* Botão X acima da janela */
  .chatbot-widget-fab-open {
    cursor: pointer;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: #ed5565;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .chatbot-widget-fab-open:hover {
    background: #da4453;
    transform: scale(1.1);
  }

  .chatbot-widget-fab-open:focus {
    outline: none;
  }

  /* Janela do chat */
  .chatbot-widget-window {
    width: 793px;
    height: calc(100vh - 125px);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    background: #fff;
  }

  .chatbot-widget-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: #1ab394;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .chatbot-widget-iframe {
    flex: 1;
    width: 100%;
    border: none;
  }

  @media (max-width: 850px) {
    .chatbot-widget-window {
      width: calc(100vw - 30px);
    }
  }

  @media (max-width: 480px) {
    .chatbot-widget-open-container {
      bottom: 10px;
      right: 10px;
    }
    .chatbot-widget-window {
      width: calc(100vw - 20px);
      height: calc(100vh - 80px);
    }
  }

  @media print {
    .chatbot-widget-fab-closed,
    .chatbot-widget-open-container {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/componentes/ChatBotWidget.vue